"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaLibraryProvider = void 0;
const media_library_dialogs_provider_1 = require("./media-library-dialogs.provider");
class MediaLibraryProvider extends media_library_dialogs_provider_1.MediaLibraryDialogsProvider {
}
exports.MediaLibraryProvider = MediaLibraryProvider;
